export const appMenuTranslationsDe = {
  users: 'Users',
  leads: 'Interessenten',
  businesspartners: 'Geschäftspartner',
  customers: 'Kunden',
  employees: 'Mitarbeiter',
  organizations: 'Organisationen',
  dispatching: 'Planung',
  accounting: 'Abrechnung',
  analysis: 'Auswertung',
  ratings: 'Bewertungen',

  admin: 'Admin',
  tickets: 'Aufgaben',
  organization: 'Organisation',
  settings: 'Einstellungen',
  documentations: 'Dokumentationen',
  appointments: 'Termine',
} as const;
